import React from 'react';
import AutoConversionTab from '../components/settings/AutoConversionTab';
import {
  useMerchantBalances,
  BalanceStatCards,
  AssetWiseBalances,
} from '../components/autoConversion/AutoConversionBalances';
import ConfigHistoryTimeline from '../components/autoConversion/ConfigHistoryTimeline';
import { useTheme } from '../context/ThemeContext';

// First-class sidebar destination for Auto-conversion (elevated out of Settings).
//
// Section order:
//   balance summary -> settings -> asset balances + config history -> conversions
//
// The settings form and the conversion history live in AutoConversionTab and
// share state, so rather than splitting a 1400-line component the page asks it
// for one section at a time via `sections`.
//
// The balance fetch is owned here because the stat cards and the balance table
// sit either side of the settings card; each fetching its own copy would issue
// the same request twice and let the two disagree mid-flight.
const AutoConversion = () => {
  // Config history is per network kind: a merchant's testnet and mainnet
  // settings are independent, and showing one while viewing the other would
  // misreport which version produced a balance.
  const { mode } = useTheme();
  const isTestnet = mode === 'test';

  const { rows, total, available, pending, loading, error, reload } = useMerchantBalances(isTestnet);

  return (
    <div className="settings-page rd-page">
      <div className="rd-page-header">
        <div>
          <h1 className="rd-page-title">Auto-conversion</h1>
          <p className="rd-page-subtitle">
            Automatically convert received crypto into your preferred settlement asset.
          </p>
        </div>
      </div>

      <div className="acp-sections">
        <BalanceStatCards
          total={total}
          available={available}
          pending={pending}
          loading={loading}
        />

        <AutoConversionTab sections={['settings']} />

        <AssetWiseBalances
          rows={rows}
          loading={loading}
          error={error}
          reload={reload}
          aside={<ConfigHistoryTimeline isTestnet={isTestnet} />}
        />

        <AutoConversionTab sections={['history']} />
      </div>

      <style jsx>{`
        .acp-sections {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
      `}</style>
    </div>
  );
};

export default AutoConversion;
